// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%239DA0A4%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#LayerDataReport {
  width: 90vw !important;
  height: 40vh !important; }

.cejst-container {
  flex-direction: column;
  height: 100%; }
  .cejst-container .cejst-map-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; }
    .cejst-container .cejst-map-container th,
    .cejst-container .cejst-map-container td {
      color: white; }
  .cejst-container .table-row {
    position: relative;
    display: flex;
    justify-content: center; }
    .cejst-container .table-row .minmax {
      position: absolute;
      top: 0%;
      right: 0%;
      z-index: 10000;
      width: 25px; }
      .cejst-container .table-row .minmax svg {
        color: white; }
  .cejst-container .cejst-table-container {
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 10;
    height: 40vh;
    overflow: auto;
    width: 90vw; }
    .cejst-container .cejst-table-container table {
      position: absolute;
      left: 0; }
    .cejst-container .cejst-table-container th,
    .cejst-container .cejst-table-container td {
      color: white; }
  .cejst-container .height-unset {
    height: 17vh; }
  .cejst-container .cejst-graph-container {
    height: 40vh; }
  .cejst-container h4 {
    text-align: right;
    color: white;
    margin-right: 1rem; }
    .cejst-container h4 a {
      color: #4fc32c;
      font-size: 18px; }
  .cejst-container .center-marker {
    color: red;
    position: absolute;
    font-size: 24px; }
  .cejst-container .cejst-content {
    display: flex;
    justify-content: center;
    flex-direction: row; }
  .cejst-container .report-data {
    position: relative;
    overflow: auto;
    right: 3%;
    margin-top: 20px;
    background-color: #002044;
    border-radius: 4px;
    box-shadow: 1px 1px 4px #496de74f;
    height: 780px;
    margin-bottom: 2rem; }
    .cejst-container .report-data .content-legend h5 {
      color: white;
      font-weight: bold;
      padding: 1rem; }
    .cejst-container .report-data .content-legend p {
      color: #dbd8d8;
      padding: 0 2rem;
      font-size: 15px; }
      .cejst-container .report-data .content-legend p .text-icon {
        font-size: 12px;
        font-weight: bold;
        margin-bottom: 6px;
        color: white; }
    .cejst-container .report-data .DM {
      cursor: pointer;
      color: #5F5D5A;
      font-size: 10px; }
  .cejst-container .accordions-container {
    position: relative;
    width: 100%;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #002044; }
    .cejst-container .accordions-container .geoID-info {
      color: white;
      width: 96%;
      border-radius: 2px;
      margin-top: 1rem; }
      .cejst-container .accordions-container .geoID-info .tract-info h5,
      .cejst-container .accordions-container .geoID-info .tract-demo h5 {
        font-size: 1rem;
        font-weight: bold;
        margin-bottom: 0; }
      .cejst-container .accordions-container .geoID-info .tract-info p,
      .cejst-container .accordions-container .geoID-info .tract-demo p {
        margin-top: 0;
        margin-bottom: -4px;
        font-size: 12px;
        margin-left: 1rem; }
      .cejst-container .accordions-container .geoID-info .tract-demo {
        margin-top: 0.5rem; }
      .cejst-container .accordions-container .geoID-info .demo-index {
        display: flex;
        justify-content: space-between;
        padding: 4px; }
      .cejst-container .accordions-container .geoID-info .is-disadvantaged {
        margin-top: 1rem;
        margin-bottom: 1rem;
        text-align: center; }
        .cejst-container .accordions-container .geoID-info .is-disadvantaged h5 {
          font-size: 1rem;
          font-weight: bold;
          margin-bottom: 1rem; }
        .cejst-container .accordions-container .geoID-info .is-disadvantaged strong {
          margin-top: 1rem; }
        .cejst-container .accordions-container .geoID-info .is-disadvantaged .flagged-score {
          background-color: orangered;
          padding: 4px;
          border-radius: 3px;
          color: white !important; }
        .cejst-container .accordions-container .geoID-info .is-disadvantaged .disadvantaged-desc {
          margin-top: 1rem;
          text-align: left; }
    .cejst-container .accordions-container .accordion-body {
      background-color: white; }
    .cejst-container .accordions-container .and {
      font-weight: bold;
      padding: 1rem;
      color: black; }
    .cejst-container .accordions-container .data-container {
      display: flex;
      justify-content: space-between;
      padding-top: 16px !important;
      padding: 1rem; }
      .cejst-container .accordions-container .data-container .desc {
        width: 10rem; }
        .cejst-container .accordions-container .data-container .desc h5 {
          font-size: 1rem;
          color: black;
          font-weight: bold; }
        .cejst-container .accordions-container .data-container .desc p {
          margin-top: 0;
          margin-bottom: rem;
          font-size: 14px;
          color: #666363; }
      .cejst-container .accordions-container .data-container .score {
        width: 4rem;
        text-align: right; }
        .cejst-container .accordions-container .data-container .score strong {
          font-size: 1rem;
          color: black;
          font-weight: bold; }
        .cejst-container .accordions-container .data-container .score p {
          margin-top: 0;
          margin-bottom: rem;
          font-size: 10px;
          color: #666363; }
      .cejst-container .accordions-container .data-container .flagged-score {
        background-color: #1A4480;
        padding: 4px;
        border-radius: 3px;
        color: white !important; }
    .cejst-container .accordions-container .accordions {
      width: 100%;
      height: 410px; }
      .cejst-container .accordions-container .accordions .accordion {
        padding: 0 2%;
        width: 98%; }
        .cejst-container .accordions-container .accordions .accordion .accordion-button,
        .cejst-container .accordions-container .accordions .accordion .accordion-button.collapsed {
          background-color: #002044;
          color: white;
          font-weight: bold; }
        .cejst-container .accordions-container .accordions .accordion .accordion-button::after {
          background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }
        .cejst-container .accordions-container .accordions .accordion .flagged-btn button {
          background-color: #E7F1FF !important;
          color: black !important; }
    .cejst-container .accordions-container .close-icon {
      position: absolute;
      cursor: pointer;
      color: white;
      right: 2%;
      top: 0.5%;
      z-index: 100; }

#LayerDataReport {
  position: relative; }
  #LayerDataReport .map-legend-container #mapLegendAccordion {
    position: absolute;
    right: 3%; }

.expanded-cejst {
  margin-top: -21% !important;
  height: 75vh !important;
  max-height: unset; }

#CEJSTReport-map {
  position: relative;
  width: 90% !important;
  height: 75% !important;
  top: -10% !important;
  left: -3% !important;
  border-radius: 4px !important;
  box-shadow: -1px -1px 8px #496de74f !important; }

.accordion-header {
  border-bottom: 'transparant';
  cursor: 'pointer'; }
`, "",{"version":3,"sources":["webpack://./src/features/reports/CEJSTReport/cejst-report.scss"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB,EAAA;;AAGzB;EACE,sBAAsB;EACtB,YAAY,EAAA;EAFd;IAKI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAA;IARjB;;MAYM,YAAY,EAAA;EAZlB;IAiBI,kBAAkB;IAClB,aAAa;IACb,uBAAuB,EAAA;IAnB3B;MAqBM,kBAAkB;MAClB,OAAO;MACP,SAAS;MACT,cAAc;MACd,WAAW,EAAA;MAzBjB;QA2BQ,YAAY,EAAA;EA3BpB;IAiCI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;IACd,WAAW,EAAA;IAxCf;MA0CM,kBAAkB;MAClB,OAAO,EAAA;IA3Cb;;MA+CM,YAAY,EAAA;EA/ClB;IAmDkB,YAAY,EAAA;EAnD9B;IAsDI,YAAY,EAAA;EAtDhB;IA0DI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB,EAAA;IA5DtB;MA8DM,cAAc;MACd,eAAe,EAAA;EA/DrB;IAoEI,UAAU;IACV,kBAAkB;IAClB,eAAe,EAAA;EAtEnB;IA0EI,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAA;EA5EvB;IAgFI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;IACb,mBAAmB,EAAA;IAxFvB;MA2FQ,YAAY;MACZ,iBAAiB;MACjB,aAAa,EAAA;IA7FrB;MAgGQ,cAAc;MACd,eAAe;MACf,eAAe,EAAA;MAlGvB;QAoGU,eAAe;QACf,iBAAiB;QACjB,kBAAkB;QAClB,YAAY,EAAA;IAvGtB;MA6GM,eAAe;MACf,cAAc;MACd,eAAe,EAAA;EA/GrB;IAoHI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB,EAAA;IA1H7B;MA6HM,YAAY;MACZ,UAAU;MACV,kBAAkB;MAClB,gBAAgB,EAAA;MAhItB;;QAoIU,eAAe;QACf,iBAAiB;QACjB,gBAAgB,EAAA;MAtI1B;;QA0IU,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,iBAAiB,EAAA;MA7I3B;QAgJoB,kBAAkB,EAAA;MAhJtC;QAmJQ,aAAa;QACb,8BAA8B;QAC9B,YAAY,EAAA;MArJpB;QAyJQ,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB,EAAA;QA3J1B;UA6JU,eAAe;UACf,iBAAiB;UACjB,mBAAmB,EAAA;QA/J7B;UAkKU,gBAAgB,EAAA;QAlK1B;UAqKU,2BAA2B;UAC3B,YAAY;UACZ,kBAAkB;UAClB,uBAAuB,EAAA;QAxKjC;UA4KU,gBAAgB;UAChB,gBAAgB,EAAA;IA7K1B;MAoLM,uBAAuB,EAAA;IApL7B;MAwLM,iBAAiB;MACjB,aAAa;MACb,YAAY,EAAA;IA1LlB;MA8LM,aAAa;MACb,8BAA8B;MAC9B,4BAA4B;MAC5B,aAAa,EAAA;MAjMnB;QAoMQ,YAAY,EAAA;QApMpB;UAsMU,eAAe;UACf,YAAY;UACZ,iBAAiB,EAAA;QAxM3B;UA4MU,aAAa;UACb,kBAAkB;UAClB,eAAe;UACf,cAAc,EAAA;MA/MxB;QAoNQ,WAAW;QACX,iBAAiB,EAAA;QArNzB;UAuNU,eAAe;UACf,YAAY;UACZ,iBAAiB,EAAA;QAzN3B;UA6NU,aAAa;UACb,kBAAkB;UAClB,eAAe;UACf,cAAc,EAAA;MAhOxB;QAqOQ,yBAAyB;QACzB,YAAY;QACZ,kBAAkB;QAClB,uBAAuB,EAAA;IAxO/B;MA+OM,WAAW;MACX,aAAa,EAAA;MAhPnB;QAkPQ,aAAa;QACb,UAAU,EAAA;QAnPlB;;UAsPU,yBAAyB;UACzB,YAAY;UACZ,iBAAiB,EAAA;QAxP3B;UA4PU,yDAAqT,EAAA;QA5P/T;UAiQY,oCAAoC;UACpC,uBAAuB,EAAA;IAlQnC;MAyQM,kBAAkB;MAClB,eAAe;MACf,YAAY;MACZ,SAAS;MACT,SAAS;MACT,YAAY,EAAA;;AAKlB;EACE,kBAAkB,EAAA;EADpB;IAIM,kBAAkB;IAClB,SAAS,EAAA;;AAKf;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,6BAA6B;EAC7B,8CAA8C,EAAA;;AAGhD;EACE,4BAA4B;EAC5B,iBAAiB,EAAA","sourcesContent":["#LayerDataReport {\n  width: 90vw !important;\n  height: 40vh !important;\n}\n\n.cejst-container {\n  flex-direction: column;\n  height: 100%;\n\n  .cejst-map-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n\n    th,\n    td {\n      color: white;\n    }\n  }\n\n  .table-row {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    .minmax {\n      position: absolute;\n      top: 0%;\n      right: 0%;\n      z-index: 10000;\n      width: 25px;\n      svg {\n        color: white;\n      }\n    }\n  }\n\n  .cejst-table-container {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    z-index: 10;\n    height: 40vh;\n    overflow: auto;\n    width: 90vw;\n    table {\n      position: absolute;\n      left: 0;\n    }\n    th,\n    td {\n      color: white;\n    }\n  }\n\n  .height-unset { height: 17vh; }\n\n  .cejst-graph-container {\n    height: 40vh;\n  }\n\n  h4 {\n    text-align: right;\n    color: white;\n    margin-right: 1rem;\n    a {\n      color: #4fc32c;\n      font-size: 18px;\n    }\n  }\n\n  .center-marker {\n    color: red;\n    position: absolute;\n    font-size: 24px;\n  }\n\n  .cejst-content {\n    display: flex;\n    justify-content: center;\n    flex-direction: row;\n  }\n\n  .report-data {\n    position: relative;\n    overflow: auto;\n    right: 3%;\n    margin-top: 20px;\n    background-color: #002044;\n    border-radius: 4px;\n    box-shadow: 1px 1px 4px #496de74f;\n    height: 780px;\n    margin-bottom: 2rem;\n    .content-legend {\n      h5 { \n        color: white;\n        font-weight: bold;\n        padding: 1rem;\n      }\n      p { \n        color: #dbd8d8;\n        padding: 0 2rem;\n        font-size: 15px;\n        .text-icon {\n          font-size: 12px;\n          font-weight: bold;\n          margin-bottom: 6px;\n          color: white;\n        }      \n      }\n    }\n\n    .DM {\n      cursor: pointer;\n      color: #5F5D5A;\n      font-size: 10px;\n    }\n  }\n\n  .accordions-container {\n    position: relative;\n    width: 100%;\n    bottom: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: #002044;\n\n    .geoID-info {\n      color: white;\n      width: 96%;\n      border-radius: 2px;\n      margin-top: 1rem;\n      .tract-info,\n      .tract-demo {\n        h5 {\n          font-size: 1rem;\n          font-weight: bold;\n          margin-bottom: 0;\n        }\n\n        p {\n          margin-top: 0;\n          margin-bottom: -4px;\n          font-size: 12px;\n          margin-left: 1rem;\n        }\n      }\n      .tract-demo { margin-top: 0.5rem; }\n\n      .demo-index {\n        display: flex;\n        justify-content: space-between;\n        padding: 4px;\n      }\n\n      .is-disadvantaged {\n        margin-top: 1rem;\n        margin-bottom: 1rem;\n        text-align: center;\n        h5 {\n          font-size: 1rem;\n          font-weight: bold;\n          margin-bottom: 1rem;\n        }\n        strong {\n          margin-top: 1rem;\n        }\n        .flagged-score {\n          background-color: orangered;\n          padding: 4px;\n          border-radius: 3px;\n          color: white !important;\n        }\n\n        .disadvantaged-desc {\n          margin-top: 1rem;\n          text-align: left;\n        }\n      }\n  \n    }\n\n    .accordion-body {\n      background-color: white;\n    }\n\n    .and {\n      font-weight: bold;\n      padding: 1rem;\n      color: black;\n    }\n\n    .data-container {\n      display: flex;\n      justify-content: space-between;\n      padding-top: 16px !important;\n      padding: 1rem;\n      \n      .desc {\n        width: 10rem;\n        h5 {\n          font-size: 1rem;\n          color: black;\n          font-weight: bold;\n        }\n\n        p {\n          margin-top: 0;\n          margin-bottom: rem;\n          font-size: 14px;\n          color: #666363;\n        }\n      }\n\n      .score {\n        width: 4rem;\n        text-align: right;\n        strong {\n          font-size: 1rem;\n          color: black;\n          font-weight: bold;\n        }\n\n        p {\n          margin-top: 0;\n          margin-bottom: rem;\n          font-size: 10px;\n          color: #666363;\n        }\n      }\n\n      .flagged-score {\n        background-color: #1A4480;\n        padding: 4px;\n        border-radius: 3px;\n        color: white !important;\n      }\n\n    }\n    \n\n    .accordions {\n      width: 100%;\n      height: 410px;\n      .accordion { \n        padding: 0 2%;\n        width: 98%;\n        .accordion-button,\n        .accordion-button.collapsed {\n          background-color: #002044;\n          color: white;\n          font-weight: bold;\n        }\n\n        .accordion-button::after {\n          background-image: url('data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%239DA0A4%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e');\n        }\n\n        .flagged-btn {\n          button {\n            background-color: #E7F1FF !important;\n            color: black !important;\n          }\n        }\n      }\n    }\n\n    .close-icon {\n      position: absolute;\n      cursor: pointer;\n      color: white;\n      right: 2%;\n      top: 0.5%;\n      z-index: 100;\n    }\n  }\n}\n\n#LayerDataReport {\n  position: relative;\n  .map-legend-container {\n    #mapLegendAccordion {\n      position: absolute;\n      right: 3%;\n    }\n  }\n}\n\n.expanded-cejst {\n  margin-top: -21% !important;\n  height: 75vh !important;\n  max-height: unset;\n}\n\n#CEJSTReport-map {\n  position: relative;\n  width: 90% !important;\n  height: 75% !important;\n  top: -10% !important;\n  left: -3% !important;\n  border-radius: 4px !important;\n  box-shadow: -1px -1px 8px #496de74f !important;\n}\n\n.accordion-header {\n  border-bottom: 'transparant';\n  cursor: 'pointer';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
